export const TFI_NEW_URL = process.env.REACT_APP_TFI_NEW_URL;

